import { useCallback, useState } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

import { ALL_SERVICE_TYPES_KEY } from '../../../Services.constants';

const DEFAULT_PER_PAGE = 10;

const useCategoryExpand = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [serviceTypeFilter, setServiceTypeFilter] = useState(ALL_SERVICE_TYPES_KEY);

  const { page, perPage, setPage, setPerPage, searchString, setSearchString, currentSearch } =
    usePaginationParams(DEFAULT_PER_PAGE);

  const handleToggleExpand = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  const handleSearchChange = useCallback(
    (value: string) => {
      setSearchString(value);
      setPage(1);
    },
    [setSearchString, setPage]
  );

  const handleServiceTypeChange = useCallback(
    (value: string) => {
      setServiceTypeFilter(value);
      setPage(1);
    },
    [setPage]
  );

  const handlePageChange = useCallback(
    (value: number) => {
      setPage(value);
    },
    [setPage]
  );

  const handlePerPageChange = useCallback(
    (value: number) => {
      setPerPage(value);
      setPage(1);
    },
    [setPerPage, setPage]
  );

  return {
    isExpanded,
    searchString,
    currentSearch,
    serviceTypeFilter,
    page,
    perPage,
    handleToggleExpand,
    handleSearchChange,
    handleServiceTypeChange,
    handlePageChange,
    handlePerPageChange,
  };
};

export default useCategoryExpand;
